"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import React from "react";
import "home/Transitions.css";
import { Navbar } from "home/Navbar";
import { Hero } from "home/Hero";
import dynamic from "next/dynamic";
// Steps contains 4 large SVGs (~800KB) with embedded base64 PNGs.
// Lazy-loading isolates them into a separate async chunk so they never
// land in a shared chunk that loads on /resume-builder.
const Steps = dynamic(() => import("home/Steps").then(m => m.Steps), {
  ssr: false
});
import { Cta } from "home/Cta";
import { Footer } from "home/Footer";
import { HeroMobile } from "home/HeroMobile";
// import {Templates} from "home/Templates"

// Lazy-load heavy client components to reduce initial hydration/TBT.
// Load only after user interaction or on viewport entry
const Templates = dynamic(() => import("home/Templates").then(mod => mod.Templates), {
  ssr: false,
  loading: () => <section className="relative overflow-hidden bg-[#F9F9F9]">
        <div className="text-center font-montserrat tracking-tight text-[#2B282B]">
          <div className="h-28 md:h-32 lg:h-40" />
        </div>
      </section>
});
const Testimonials = dynamic(() => import("home/Testimonials").then(m => m.Testimonials), {
  ssr: false,
  loading: () => <section>
      <div className="text-center font-montserrat tracking-tight text-[#2B282B]">
        <div className="h-20" />
      </div>
    </section>
});

// Score component is below fold, load with lower priority
const Score = dynamic(() => import("home/Score"), {
  ssr: false,
  loading: () => <div className="w-full min-h-[600px] bg-gray-100" />
});
import { AuthenticationOptions } from "components/AuthenticationOptions";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAppSelector, useSaveStateToLocalStorageOnChange, useSetInitialStore } from "lib/redux/hooks";
// import SubscriptionOverlay from "components/Subscription";
import { selectIsAuthenticationOpen } from "lib/redux/uiSlice";
import FAQ from "home/faq";
import { accordianList } from "home/constants";
// import Image from "next/image";

export default function Home() {
  const $ = _c(21);
  useSetInitialStore();
  useSaveStateToLocalStorageOnChange();
  const isAuthenticationOpen = useAppSelector(selectIsAuthenticationOpen);
  let t0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Navbar />;
    t1 = <Hero />;
    t2 = <HeroMobile />;
    t3 = <div className="hero-breakdown-gradient h-10 md:h-20" />;
    t4 = <Steps />;
    t5 = <div className="hero-breakdown-gradient1 h-10 md:h-20" />;
    t6 = <Templates />;
    t7 = <div className="h-10 md:h-20" />;
    t8 = <Score />;
    t9 = <div className="h-10 md:h-20" />;
    t10 = <Testimonials />;
    t11 = <div className="h-10 md:h-20" />;
    t12 = <FAQ accordianList={accordianList} />;
    t13 = <div className="h-10 md:h-20" />;
    t14 = <Cta />;
    t15 = <Footer />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t10;
    $[3] = t11;
    $[4] = t12;
    $[5] = t13;
    $[6] = t14;
    $[7] = t15;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t0 = $[0];
    t1 = $[1];
    t10 = $[2];
    t11 = $[3];
    t12 = $[4];
    t13 = $[5];
    t14 = $[6];
    t15 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  let t16;
  if ($[16] !== isAuthenticationOpen) {
    t16 = isAuthenticationOpen && <AuthenticationOptions />;
    $[16] = isAuthenticationOpen;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={true} draggable={true} pauseOnHover={true} theme="light" />;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] !== t16) {
    t18 = <main className="overflow-hidden bg-[#F9F9F9]">{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}</main>;
    $[19] = t16;
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  return t18;
}